export enum ButtonModeEnum {
  UPDATE = 'update',
  DECISION = 'decision',
  CORRECTION = 'correction',
  CORRECTION_DECISION = 'correctionDecision',
}
